import { put, call, select, all } from 'redux-saga/effects'

import { snackbarActions } from 'reduxModules/actions/SnackbarActions'
import { blacklistActions } from 'reduxModules/actions/BlacklistActions'
import { limitSelector } from 'reduxModules/selectors/RouteSelectors'
import {
  handleRouteLimit,
  handleRouteInfo,
  updateTotalSheetBookings
} from 'services/sagaHelpers'
import {
  userNameSelector,
  userRoleSelector,
  companySelector,
  isPrexBusSelector
} from 'reduxModules/selectors/UserSelectors'
import { confirmSaga } from 'services/sagaHelpers'


import { firebase, firestore, rsf } from '../../firebase'
import { createReadableDateTime, handlePhoneNumber } from "services/helpers";

export function* getBlacklistPassengerBookingsSaga(action) {
  const { responseSuccess, responseFailure, data: passenger } = action

  try {
    const { blacklistIDs } = passenger

    const res = yield all(
      blacklistIDs.map(id => call(rsf.firestore.getDocument, `bookings/${id}`))
    )

    if (!res.empty) {
      const bookings = []

      res.forEach(booking => bookings.push({ id: booking.id, ...booking.data() }))

      yield put(responseSuccess(bookings))
    } else {
      yield put(responseFailure())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження бронювань пасажира!'
    }))
  }
}


export function* getBlacklistBookingsSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const company = yield select(companySelector)
    const isPrexBus = yield select(isPrexBusSelector)
    const colRef = firestore.collection('passengers')
    const query = isPrexBus
      ? colRef.where('blacklistIDs', '>', [])
      : colRef
        .where('blacklistIDs', '>', [])
        .where('company', '==', company)

    const res = yield call(rsf.firestore.getCollection, query)

    if (!res.empty) {
      const blacklistBookings = []

      res.forEach(passenger => blacklistBookings.push({
        id: passenger.id,
        phone: passenger.id,
        ...passenger.data()
      }))

      yield put(responseSuccess(blacklistBookings))
    } else {
      yield put(responseSuccess([]))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure(err))
  }
}

export function* addBlacklistBookingSaga(action) {
  const { responseSuccess, responseFailure, data: booking } = action
  const lastModified = createReadableDateTime(new Date())

  try {
    const phoneNumber = handlePhoneNumber(booking.phone)
    const userRole = yield select(userRoleSelector)
    const userName = yield select(userNameSelector)
    const company = yield select(companySelector)

    const confirmed = yield call(confirmSaga, 'addBlacklistBooking')
    if (confirmed) {
      yield call(
        rsf.firestore.setDocument,
        `passengers/${phoneNumber}`,
        {
          lastModified: lastModified,
          blacklistIDs: firebase.firestore.FieldValue.arrayUnion(booking.id),
          userName,
          userRole,
          company
        },
        { merge: true }
      )

      yield call(
        rsf.firestore.setDocument,
        `bookings/${booking.id}`,
        { status: 'blacklist' },
        { merge: true }
      )

      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Бронювання успішно добавлено в чорний список!'
      }))

      const limit = yield select(limitSelector)

      yield handleRouteLimit(+limit + 1)
      yield updateTotalSheetBookings()

      yield put(responseSuccess())
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час додавання в чорний список!'
    }))
  }
}

export function* deleteBlacklistBookingSaga(action) {
  const { responseSuccess, responseFailure, data: booking } = action

  try {
    const phoneNumber = handlePhoneNumber(booking.phone)
    const confirmed = yield call(confirmSaga, 'deleteBlacklistBooking')

    if (confirmed) {
      yield call(
        rsf.firestore.setDocument,
        `passengers/${phoneNumber}`,
        { blacklistIDs: firebase.firestore.FieldValue.arrayRemove(booking.id) },
        { merge: true }
      )

      yield call(
        rsf.firestore.setDocument,
        `bookings/${booking.id}`,
        { status: 'null' },
        { merge: true }
      )

      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Бронювання успішно видалено з чорного списку!'
      }))

      yield handleRouteInfo([booking])

      yield put(blacklistActions.getBlacklistBookings())
    }
    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час видалення бронювання з чорного списку!'
    }))
  }
}

export function* deleteBlacklistPassengerSaga(action) {
  const { responseSuccess, responseFailure, data: passenger } = action

  try {
    const { blacklistIDs, id } = passenger
    const confirmed = yield call(confirmSaga, 'deleteBlacklistPassenger')

    if (confirmed) {
      yield all(
        blacklistIDs.map(booking =>
          call(
            rsf.firestore.setDocument,
            `bookings/${booking}`,
            { status: 'null' },
            { merge: true }
          )
        ))

      yield call(
        rsf.firestore.setDocument,
        `passengers/${id}`,
        { blacklistIDs: [] },
        { merge: true }
      )

      yield put(snackbarActions.showSnackbar({
        type: 'success',
        message: 'Пасажира успішно видалено з чорного списку!'
      }))

      yield put(blacklistActions.getBlacklistBookings())

      yield put(blacklistActions.blacklistHandleRouteInfo(blacklistIDs))
    }
    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час видалення пасажира з чорного списку!'
    }))
  }
}

export function* blacklistHandleRouteInfoSaga(action) {
  const { responseSuccess, responseFailure, data: blacklistIDs } = action

  try {
    const res = yield all(
      blacklistIDs.map(booking => call(rsf.firestore.getDocument, `bookings/${booking}`))
    )

    const bookings = []
    res.forEach(booking => bookings.push(booking.data()))

    yield all(
      bookings.map(function* (booking) {
        const { routeId, departureDate } = booking

        const dateId = departureDate.replace(/\//g, '_')
        const dateIdArray = dateId.split('_')
        const month = dateIdArray[1]
        const year = dateIdArray[2]

        const route = yield call(rsf.firestore.getDocument, `routes/${routeId}/info/${dateId}`)
        const routeData = route.data()

        const { limit, totalSheetBookings } = routeData

        yield call(
          rsf.firestore.setDocument,
          `routes/${routeId}/info/${dateId}`,
          {
            month,
            year,
            limit: limit - 1 < 0 ? 0 : limit - 1,
            totalSheetBookings: totalSheetBookings
              ? totalSheetBookings + 1
              : 1,
          },
          { merge: true }
        )
      })
    )

    yield put(responseSuccess())
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/BlacklistSagas.js